<mat-card>
  <mat-card-content>

    <ngx-mat-facet-search #search [source]="facets" (searchUpdated)="output.filterUpdated($event)" [chipLabelsEnabled]="settings.chipLabelsEnabled"
                          [confirmOnRemove]="settings.confirmOnRemove" [clearButtonEnabled]="settings.clearButtonEnabled" placeholder="Add a filter..." clearButtonText="CLEAR FILTERS">
    </ngx-mat-facet-search>

  </mat-card-content>
</mat-card>

<mat-divider></mat-divider>

<div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="15px" class="content">

  <app-settings #settings (facetsUpdated)="facetsUpdated($event)"  [currentIdentifier]="search.identifier" [strategy]="search.getIdentifierStrategy()" (strategyUpdated)="strategyUpdated($event)" (manualIdentifierUpdated)="manualIdentifierUpdated($event)"></app-settings>
  <mat-divider [vertical]="true"></mat-divider>
  <app-output #output></app-output>

</div>
